const messages = {
  title: "Cenu saraksti un produktu brošūras",
  title_media: "Cenu saraksti un produktu brošūras",
  description:
    "Lejupielādējiet jaunākās brošūras un bukletus par Bridgestone un Firestone riepām vieglajiem auto, SUV un komerciālajiem transportlīdzekļiem.",
  short_description:
    "Šeit varat atrast materiālus sociālajiem tīkliem, in-store TV un citiem kanāliem.",
  mediaCategories: {
    products: "Produkti",
    brand_and_solutions: "Zīmols un risinājumi",
    season_and_promotions: "Sezona un akcijas",
    format: "Formāts",
    cars_and_vans: "Vieglā auto, SUV, komercauto",
    truck_and_buses: "Smagā auto un autobuss",
    motorcycle: "Motocikls",
    agriculture: "Lauksaimniecība",
    construction_machinery: "Būvtehnika",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiāli",
    brochures: "Produktu brošūras",
    price_list: "Cenu saraksti",
    materials: "Materiāli",
    video_in_store: "Video ar subtitriem",
    video_online: "Video bez subtitriem",
    video: "Video",
    banner_website: "Baneris",
    banner_social_media: "Sociālie mediji",
    logos: "Logotipi",
    summer: "Vasara",
    winter: "Ziema",
    all_season: "Visas sezonas",
    promotions: "Akcijas",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIJU BIBLIOTĒKA",
    description:
      "Laipni lūdzam mediju sadaļā, kas veltīta   \n" +
      "Bridgestone un Firestone produktiem.  \n <br> <br>" +
      "Jūs atklāsiet produktu vizuālos,   \n" +
      "logotipus, kā arī plašu   \n" +
      "baneru, video un digitālo materiālu   \n" +
      "izlasi, ko izmantot savā vietnē vai   \n" +
      "sociālajos medijos.  ",
    bDrive: {
      title: "Produktu fotogrāfijas",
      description:
        "Pašreizējos attēlus   \n" +
        "var lejupielādēt   \n" +
        "no mūsu B-\n" +
        "DRIVE portāla.  ",
    },
  },
  buttons: {
    media: "ATKLĀT",
  },
  searchMedia: "Ievadiet atslēgvārdu",
  searchResults: "Meklēšanas rezultāti",
};

export default {
  messages,
};
